
import {
  Vue,
  Prop,
  Component,
} from 'vue-property-decorator';

@Component
export default class TMessage extends Vue {
  private visable: boolean = true

  @Prop({
    type: String,
    default: '',
  }) title?: string;

  @Prop({
    type: String,
    default: '',
  }) iconImg?: string;

  @Prop({
    type: Boolean,
    default: false,
  }) closable?: boolean;

  @Prop() closeHandler!: Function;
}
